import React from 'react'
import { useFormContext } from '@/components'
import { Button, Tooltip } from '@mantine/core'
import { useHostZoneQuery } from '../queries'
import { UnstakeFormType } from './useUnstakeForm'
import { useSelectedDenom } from '@/contexts/denom'
import { useSelectedChain, useStrideChain } from '@/contexts/wallet'
import { CHAIN_INFO_LIST, CHAIN_SUPPORTS_UNSTAKING } from '@/config'

const UnstakeButton: React.FC = () => {
  const { address: strideAddress, connect, status } = useStrideChain()

  const { address: selectedAddress } = useSelectedChain()

  const { values, errors } = useFormContext<UnstakeFormType>()

  const { data: hostZone, error: hostZoneError } = useHostZoneQuery()

  const [denom] = useSelectedDenom()

  if (!strideAddress || !selectedAddress) {
    return (
      <Button
        type="submit"
        fullWidth
        size="lg"
        radius="md"
        onClick={() => connect()}
        loading={status === 'Connecting'}
        styles={(t) => ({
          root: {
            transition: 'background 0.1s',
            '&:not(:disabled):hover': {
              backgroundColor: '#F50D8F',
              transform: 'translateY(0)'
            },
            '&:not(.__mantine-ref-loading):disabled': {
              backgroundColor: t.colors.gray[1],
              color: t.colors.gray[4]
            }
          }
        })}>
        Connect Wallet
      </Button>
    )
  }

  const selectedChainName = CHAIN_INFO_LIST[denom].chainName

  const tooltipMessage =
    !CHAIN_SUPPORTS_UNSTAKING[denom] && denom === 'DYDX'
      ? `Redemption of st${denom} is disabled for the launch period (72 hours)`
      : !CHAIN_SUPPORTS_UNSTAKING[denom] && denom === 'TIA'
        ? `Redemption of st${denom} is disabled for the launch period (24 hours)`
        : !CHAIN_SUPPORTS_UNSTAKING[denom] && denom === 'DYM'
          ? `Redemption of st${denom} is disabled for the launch period (72 hours)`
          : !CHAIN_SUPPORTS_UNSTAKING[denom] && denom === 'SAGA'
            ? `Redemption of st${denom} is disabled for the launch period (24 hours)`
            : !CHAIN_SUPPORTS_UNSTAKING[denom] && denom === 'ISLM'
              ? `Redemption of st${denom} is disabled for the launch period (72 hours)`
              : !CHAIN_SUPPORTS_UNSTAKING[denom] && denom === 'BAND'
                ? `Redemption of st${denom} is disabled for the launch period (72 hours)`
                : !CHAIN_SUPPORTS_UNSTAKING[denom]
                  ? `Redemption of st${denom} tokens is disabled for the time being.`
                  : hostZone?.halted
                    ? `Unstaking from ${selectedChainName} has been disabled temporarily due to rate limiting.`
                    : hostZoneError
                      ? 'Unable to load host zone information. Please refresh the page or try again in a few minutes.'
                      : ''

  const isDisabled = Boolean(tooltipMessage || errors.amount || !values.amount)

  return (
    <Tooltip label={tooltipMessage} disabled={!tooltipMessage} sx={{ width: '100%' }} withinPortal>
      <Button
        type="submit"
        fullWidth
        size="lg"
        radius="md"
        disabled={isDisabled}
        styles={(t) => ({
          root: {
            transition: 'background 0.1s',
            '&:not(:disabled):hover': {
              backgroundColor: '#F50D8F',
              transform: 'translateY(0)'
            },
            '&:not(.__mantine-ref-loading):disabled': {
              backgroundColor: t.colors.gray[1],
              color: t.colors.gray[4]
            }
          }
        })}>
        Redeem
      </Button>
    </Tooltip>
  )
}

export { UnstakeButton }
